import {NgModule} from "@angular/core";
import {ProductCardModule} from "./product-card/product-card.module";
import {ProductComponent} from "./product.component";
import {
    FeaturedProductsRowComponent
} from "../marketing-pages/placeholder/featured-products-row/featured-products-row.component";
import {
    FeaturedProductsRowEmbedComponent
} from "../marketing-pages/placeholder/featured-products-row/featured-products-row-embed.component";
import {SharedModule} from "../../shared.module";
import {ProductSelectionModule} from "../product-selection/product-selection.module";
import {ProductReviewModule} from "../productreview/product-review.module";
import {ProductThumbCarouselModule} from "./product-thumb-carousel/product-thumb-carousel.module";
import {ProductDrawerModule} from "./product-drawer/product-drawer.module";
import {CarouselModule} from "ngx-bootstrap/carousel";
import {
    FeaturedProductsRowGuidedComponent
} from "../marketing-pages/placeholder/featured-products-row-guided/featured-products-row-guided.component";
import {SkinAnalyzerModule} from "../skin-analyzer/skin-analyzer.module";
import {PdpCmsComponent} from "./pdp-cms/pdp-cms.component";
import {PdpTemplateComponent} from '@usana/ux/cms';
import {LocaleModule} from "../locale/locale.module";
import {ProductBuyBoxModule} from "./buy-box/product-buy-box.module";

@NgModule({
    imports: [
        PdpTemplateComponent,
        ProductBuyBoxModule,
        ProductCardModule,
        ProductDrawerModule,
        ProductReviewModule,
        ProductSelectionModule,
        ProductThumbCarouselModule,
        SharedModule,
        CarouselModule,
        SkinAnalyzerModule,
        LocaleModule
    ],
    declarations: [
        FeaturedProductsRowComponent,
        FeaturedProductsRowEmbedComponent,
        FeaturedProductsRowGuidedComponent,
        PdpCmsComponent,
        ProductComponent,
    ],
    exports: [
        FeaturedProductsRowComponent,
        FeaturedProductsRowEmbedComponent,
        FeaturedProductsRowGuidedComponent,
        PdpCmsComponent,
        ProductBuyBoxModule,
        ProductCardModule,
        ProductComponent,
        ProductDrawerModule
    ]
})
export class ProductModule { }
